import { getGraphFromProject } from '../utils/utils';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import Errored from '../../core/Errored';
import Loading from '../../core/Loading';
import { makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import ProjectCard from './ProjectCard';

class Projects extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isErrored: null
    };
    this.cancellable = null;
  }

  componentDidMount() {
    // We load ALL the projects necessary at this level in one API call to avoid unnecessary calls
    try {
      if (this.props.projects) {
        this.loadData()
          .promise
          .then(() => {
            if (this.cancellable && this.cancellable.isCancelled()) return;
            this.setState({ isLoading: false });
          })
          .catch((e) => {
            if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
          });
      }
      else {
        if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isLoading: false });
      }
    }
    catch (e) {
      if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
    }
  }

  loadData() {
    const projectsData = this.props.projects.map(projectIRI => {
      return {
        graph: getGraphFromProject(projectIRI),
        iri: projectIRI
      };
    });
    this.cancellable = makeCancelable(GS.loadDataFromGraph(projectsData));
    return this.cancellable;
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
  }

  render() {

    const { isLoading, isErrored } = this.state;
    const { projects, lang, onDeleteProject, applicationURL, entitlement, lockedGraphs } = this.props;

    if (isErrored) return <Errored data={isErrored} />;
    if (isLoading) return <Loading />;

    return (
      <Grid data-test="project-list" container spacing={4} justifyContent="space-evenly">
        {projects.map((project) => 
          <Grid key={"project-grid-" + project} item xs={12} sm={6} md={4} lg={3}>
            <ProjectCard
              applicationURL={applicationURL}
              key={project}
              id={project}
              locked={lockedGraphs && lockedGraphs.includes(getGraphFromProject(project))}
              entitlement={entitlement}
              graph={getGraphFromProject(project)}
              lang={lang}
              onDeleteProject={onDeleteProject} />
          </Grid>
        )}
      </Grid>
    );
  }
}

Projects.defaultProps = {
  locked: false
};

Projects.propTypes = {
  lockedGraphs: PropTypes.array,
  lang: PropTypes.string,
  projects: PropTypes.array,
  entitlement: PropTypes.string.isRequired,
  applicationURL: PropTypes.string.isRequired,
  onDeleteProject: PropTypes.func.isRequired
};

export default Projects;